<template>
  <layout-vertical>

    <router-view/>

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar v-if="$store.state.app.isAdmin" :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      <navbar-front v-else :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'
import NavbarFront from '../components/NavbarFront.vue'

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    Navbar,
    NavbarFront,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
